export const esp_text = {
  credential_disclaimer: "Solo dos credenciales por persona",
  corresponsal_name: "Nombre del corresponsal",
  id_disclaimer: "Nombre como aparece en el ID",
  cameraman_name: "Nombre del camarografo",
  email_cameraman: "Email del camarografo",
  email_correspondent: "Email del corresponsal",
  platform_name: "Nombre de la plataforma",
  platform_website: "Página web de la plataforma",
  social_media: "Redes sociales de la plataforma",
  leave_blank: "dejar en blanco en caso de no tener",
  how_many_credentials: "¿Cuántas credenciales requieren?",
  people_credentials_name: "Nombre de las personas para las credenciales",
  people_credentials_name_help:
    "Separar nombres por coma. Ej: Erik Sanchez, Mauricio James, etc",
  phone_number: "Número de telefono",
  phone_country_code: "Agregar código de país",
  name: "Nombre...",
  email_placeholder: "E-Mail...",
  url: "URL...",
  thanks_for_submit: "Gracias por participar, la informacion ha sido enviada",
  close_page: "Ya puedes cerrar la pagina",
};
